function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVictoryReactionsWow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 325.13 325.13",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 162.56,
    cy: 162.57,
    r: 150.03,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,99.2c18-22.23,40.52-30.12,64.7-14.55",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.09,85.42c25.6-12.74,49.36-10.53,64.87,13.7",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.56,
    cy: 223.38,
    rx: 46.01,
    ry: 49.24,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "25.06999969482422px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.54,
    cy: 131.05,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.57,
    cy: 131.05,
    r: 12,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 24
    }
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVictoryReactionsWow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Victory_Reactions_Wow.60289ffa.svg";
export { ForwardRef as ReactComponent };